module.exports = __webpack_public_path__ + "img/MenuClose.8a7c4b51.svg";